import { blogPosts } from '@/lib/blog';
import { buildPublicRoutes, type PublicRoute } from './public-routes';

/**
 * The public route registry as the running app sees it: the static routes plus
 * one route per published blog post. The build emits the same list from
 * `scripts/seo-artifacts.ts` for the prerender, sitemap and robots steps, which
 * cannot import MDX content.
 */
export const PUBLIC_ROUTES: readonly PublicRoute[] = buildPublicRoutes(
  blogPosts.map((post) => post.frontmatter),
);

export function findPublicRoute(path: string): PublicRoute | undefined {
  return PUBLIC_ROUTES.find((route) => route.path === path);
}
